import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  searchBarInput: {
    padding: '10px', // Beispiel: Padding für die Suchleiste
  },
  searchBarOutline: {
    borderColor: '#ccc', // Beispiel: Rahmenfarbe der Suchleiste
  },
}));

export default useStyles;